import React from "react";
import Switch from "@mui/material/Switch";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
    width: "50px",
    height: "24px",
    padding: "0px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#23bf58",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
      position: "absolute",
      top: "6px",
    },
    "&:after": {
      content: "'On'",
      left: "8px",
    },
    "&:before": {
      content: "'Off'",
      right: "7px",
    },
  },
  checked: {
    color: "#23bf58 !important",
    transform: "translateX(26px) !important",
  },
});

export const Toggle = (props) => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    checkedA: props.toggleValue,
  });

  const handleChange = (bookingType) => {
    setState({ ...state, [bookingType.target.name]: bookingType.target.checked });
    bookingType.target.value = bookingType.target.checked;
    props.onChange && props.onChange(bookingType, "onJob");
  };

  return (
    <div>
      <Switch
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        checked={state.checkedA}
        onChange={handleChange}
        name="checkedA"
        inputProps={{ "aria-label": "secondary checkbox" }}
      />
    </div>
  );
};

export default Toggle;
